import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { constants } from 'src/environments/constants';
import { getISODate, getKalDateFromObject } from 'src/app/utils/date.utils';
import { buildProviders, ListingFiltersComponent } from 'src/app/_shared/components/listing/listing-filters.component';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'app-shared-invoices-filters',
    templateUrl: './shared-invoices-filters.component.html',
    styleUrls: ['./shared-invoices-filters.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: buildProviders(SharedInvoicesFiltersComponent),
    standalone: false
})
export class SharedInvoicesFiltersComponent extends ListingFiltersComponent implements OnInit {

    typesFactures = [
        {code: 'IsFacture', label: 'Factures'},
        {code: 'IsAvoir', label: 'Avoirs'},
        {code: 'IsAcompte', label: 'Acomptes'}
    ];

    statutsFactures = [
        {code: constants.facture.statut.SOLDE, label: 'Soldée'},
        {code: constants.facture.statut.PARTIELLEMENT_SOLDE, label: 'Partiellement soldée'},
        {code: constants.facture.statut.NON_SOLDE, label: 'Non soldée'},
    ];

    form: UntypedFormGroup;

    @Input() beneficiaryId = null;

    constructor(protected cdr: ChangeDetectorRef,
                private fb: UntypedFormBuilder) {
        super(cdr);
    }

    get filters(): Record<string, any> {
        const filters = super.filters;
        const formatDate = (property) => getKalDateFromObject(filters.DateFacture, property);
        filters.DateFacture = {startDate: formatDate('startDate'), endDate: formatDate('endDate')};

        return filters;
    }

    private get defaultFilters(): Record<string, any> {
        return SharedInvoicesFiltersComponent.defaultFilters(this.beneficiaryId);
    }

    static defaultFilters = (beneficiaryId) => {
        return {
            TypesFactures: beneficiaryId ? ['IsFacture', 'IsAvoir', 'IsAcompte'] : ['IsFacture'],
            StatutsFactures: [
                constants.facture.statut.NON_SOLDE,
                constants.facture.statut.PARTIELLEMENT_SOLDE
            ],
            IdBenef: beneficiaryId || null,
            IsFactureClient: true,
        };
    }

    searchBarValue(): string {
        return this.filters.RechercheString;
    }

    updateForm(filters = this.filters): void {
        this.form.patchValue(filters, {emitEvent: false});
        this.cdr.markForCheck();
    }

    transformFilters(searchbar: string): Record<string, any> {
        const filters = {...this.form.value};
        const {startDate, endDate} = filters.DateFacture || {};

        filters.DateFacture = (startDate || endDate) ? {
            startDate: getISODate(startDate),
            endDate: getISODate(endDate)
        } : null;
        filters.RechercheString = searchbar;
        filters.IdBenef = this.beneficiaryId || filters.IdBenef;
        filters.IsFactureClient = true;

        if (!filters.IsSupprimer) {
            delete filters.IsSupprimer;
        }

        return filters;
    }

    cancelFilters(): void {
        this.updateForm();
    }

    resetFilters(): void {
        this.form.reset(this.defaultFilters);
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            IdBenef: [null],
            DateFacture: [null],
            TypesFactures: [null],
            StatutsFactures: [null],
            IsSupprimer: [null]
        });

        this.updateForm({
            ...this.defaultFilters,
            ...this.filters
        });

    }

}
